// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"1a323da9","66":"b66f3c16","74":"701ee2cf","455":"f2fbff1d","605":"d0e6b28d","644":"393f96c4","691":"c126b8a2","800":"fb21971f"}[chunkId] + ".chunk.js";
};